import { api, formatParams, config } from "@/utils/axios";

// 获取菜单列表
export function getMenu(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/menu/findAll`,
    })
  );
}

// 获取菜单树
export function getMenuTree(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/menu/treeList`,
    })
  );
}

// 删除菜单
export function deleteMenu(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/menu/del/${params.id}`,
    })
  );
}

// 新增菜单
export function addMenu(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/menu/save`,
    })
  );
}

// 编辑菜单
export function updateMenu(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/menu/update/${params.id}`,
    })
  );
}
